import { render, staticRenderFns } from "./footerBody.vue?vue&type=template&id=65a499c0&scoped=true&"
import script from "./footerBody.vue?vue&type=script&lang=js&"
export * from "./footerBody.vue?vue&type=script&lang=js&"
import style0 from "./footerBody.vue?vue&type=style&index=0&id=65a499c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a499c0",
  null
  
)

export default component.exports